import api from './Api'; // Adjust the path based on your project structure

const BASE_URL = 'advertisers/';

export default {
    getAll: () => {
        return api.get(`${BASE_URL}admin`);
    },
    getSingleAdvertiserForAdminSettings: (id) => {
        return api.get(`${BASE_URL}admin/${id}`);
    },
    getAllForUser: () => {
        return api.get(`${BASE_URL}user`);
    },  
    getAllNames: () => {
        return api.get(`${BASE_URL}names`);
    },      
    add: (body) => {
        return api.post(BASE_URL, body);
    },
    update: (id, body) => {
        return api.put(`${BASE_URL}${id}`, body);
    },
    addDeal: (advertiserId, body) => {
        return api.put(`${BASE_URL}${advertiserId}/add-deal`, body);
    },
    // Add a brand link to a site, by admin or user
    requestAffiliateLink: (userId,advertiserId, siteId, market, voonixAdvertiserId, dealId, isPublic, version) => {
        return api.post(`${BASE_URL}${advertiserId}/sites/${siteId}`, {
            userId,
            market,
            voonixAdvertiserId,
            dealId,
            isPublic,
            version
        });
    },
    createToplistAndRequestAffiliateLink: (advertiserId, market, voonixAdvertiserId, dealId,isPublic, version, siteName, siteType) => {
        return api.post(`${BASE_URL}${advertiserId}/toplists`, {
            market,
            voonixAdvertiserId,
            dealId,
            isPublic,
            version,
            siteName,
            siteType
        });
    },
    getAllAdvertisersWithLinks: () => {
        return api.get(`${BASE_URL}advertisers-with-links`);
    },
    // getRequestedLinks: () => {
    //     return api.get(`${BASE_URL}links`, {
    //         params: {
    //             status: 'requested'
    //         }
    //     });
    // },
    // getAllSiteLinksExceptRequested: () => {
    //     return api.get(`${BASE_URL}links`);
    // },
};
